import React from 'react';
import { useIntl } from 'react-intl';
import { CenteredFlexBox } from '../../../../../../Components/FlexBox';
import { Typography, Grid } from '@mui/material';
import capitalize from '../../../../../../Helpers/StringsFormatting/capitalize';
import Chip from '../../../../../../Components/Chip';
import CaptionValue from '../../../../../../Components/CaptionValue/CaptionValue';
import {
  ACTIVITY_TYPES_ICONS,
  ACTIVITY_TYPES_COLORS,
} from '../../../../../../Utils/constants/activityTypes';

const DefaultDialogContent = function DefaultDialogContent({
  name,
  campaignAdvancement,
  activityTypes,
  activityTypeName,
  extensionData,
}) {
  const intl = useIntl();
  const { nextActType, shouldSync } = {
    nextActType: extensionData?.NextActType || extensionData?.nextActType,
    shouldSync: extensionData?.ShouldSync || extensionData?.shouldSync,
  };

  const nextActivityType = (activityTypes || []).find(
    ({ id }) => id === nextActType
  )?.name;
  const NextActivityIcon = ACTIVITY_TYPES_ICONS[nextActivityType];
  const Icon = ACTIVITY_TYPES_ICONS[activityTypeName];

  return (
    <Grid
      container
      spacing={4}
      sx={{
        alignItems: "center",
        width: '100%'
      }}>
      <Grid size={8}>
        <CenteredFlexBox gap="16px">
          {Icon && (
            <Icon sx={{ color: ACTIVITY_TYPES_COLORS[activityTypeName] }} />
          )}
          <Typography variant="h6">
            {capitalize(intl.messages[name?.toUpperCase()] ?? name)}
          </Typography>
        </CenteredFlexBox>
      </Grid>
      <Grid size={4}>
        <Chip
          id={`${name}-${activityTypeName}-percentage`}
          variant="outlined"
          label={`${campaignAdvancement}%`}
          fontSize="1.5rem"
          color="#1D5B9D"
        />
      </Grid>
      {nextActivityType && (
        <>
          <Grid size={8}>
            <CaptionValue
              caption="NEXTACTIVITYTYPE"
              captionColor="primary"
              captionStyle={{ fontWeight: 'bold', textTransform: 'uppercase' }}
              value={
                <CenteredFlexBox gap="8px">
                  {NextActivityIcon && (
                    <NextActivityIcon
                      sx={{
                        color: ACTIVITY_TYPES_COLORS[nextActivityType],
                      }}
                    />
                  )}
                  <Typography variant="body1">
                    {intl.messages[nextActivityType] ?? nextActivityType}
                  </Typography>
                </CenteredFlexBox>
              }
            />
          </Grid>
          <Grid size={4}>
            <CaptionValue
              caption="SHOULDSYNC"
              captionColor="primary"
              captionStyle={{ fontWeight: 'bold', textTransform: 'uppercase' }}
              value={shouldSync ? intl.messages.YES : intl.messages.NO}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default DefaultDialogContent;
